import { OrderActionType } from 'enums/modules/order/orderActionType';
import { useTranslation } from 'react-i18next';

const useOrderActionName = (action: OrderActionType): string => {
  const { t } = useTranslation();

  const data = {
    [OrderActionType.Buy]: t('orderBuyAction'),
    [OrderActionType.Sell]: t('orderSellAction'),
    [OrderActionType.BuyMargin]: t('orderBuyMarginAction'),
    [OrderActionType.SellShort]: t('orderSellShortAction'),
  };

  return data[action];
};

export default useOrderActionName;
